export default "__VITE_ASSET__7940acfa__"